<template>
  <q-dialog
    @show="onOpen()"
    @hide="onDialogHide()"
    :value="isOpen">
    <q-card>
      <q-select
        ref="colourSelect"
        filled
        v-model="selectedColour"
        use-input
        dense
        hide-selected
        @input="selectAndClose"
        input-debounce="0"
        label="Select A Colour"
        :options="filteredColours"
        @filter="filterFn"
      >
        <template v-slot:no-option>
          <q-item>
            <q-item-section class="text-grey">
              No results
            </q-item-section>
          </q-item>
        </template>
        <template v-slot:option="scope">
          <q-item
            v-bind="scope.itemProps"
            v-on="scope.itemEvents" >
            <q-item-section side>
              <div :style="{border: '1px silver solid', backgroundColor: scope.opt.hex, width: '25px',height: '25px'}"></div>
            </q-item-section>
            <q-item-section>
              <q-item-label>{{scope.opt.superGroup}}->{{scope.opt.group}}->{{scope.opt.name}} | {{scope.opt.ralName}} | {{scope.opt.pantoneName}}</q-item-label>
            </q-item-section>
          </q-item>
        </template>
      </q-select>
    </q-card>
  </q-dialog>
</template>

<script>
import store from '../store'

export default {
  name: 'ColourSelectDialog',
  computed: {
    productColours () {
      return store.state.filters.colours
    }
  },
  methods: {
    filterFn (val, update) {
      if (val === '') {
        update(() => {
          this.filteredColours = this.productColours
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.filteredColours = this.productColours.filter(v => v.name.toLowerCase().indexOf(needle) > -1)
      })
    },
    onOpen () {
      this.$refs.colourSelect.showPopup()
    },
    selectAndClose () {
      this.isOpen = false
      this.$emit('ok', this.selectedColour)
    },
    show () {
      this.selectedColour = null
      this.isOpen = true
    },
    hide () {
      this.isOpen = false
    },
    onDialogHide () {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide')
    }
  },
  data () {
    return {
      filteredColours: [],
      selectedColour: null,
      isOpen: true
    }
  }
}
</script>

<style scoped>

</style>
